import {
  GET_DASHBOARD_SUCCESS,
  GET_DASHBOARD_FAIL,
  CLEAR_DASHBOARD,
} from "./actionTypes"

const INIT_STATE = {
  dashboardData: null,
  loading: false,
  error: {},
}

const dashboard = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_DASHBOARD_SUCCESS:
      return {
        ...state,
        dashboardData: action.payload,
        loading: false,
        error: {},
      }

    case GET_DASHBOARD_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }

    case CLEAR_DASHBOARD:
      return {
        ...state,
        dashboardData: null,
        loading: false,
        error: {},
      }

    default:
      return { ...state }
  }
}

export default dashboard
